import * as React from "react";
import styled from "@mui/material/styles/styled";
import { GenericButton } from "./uiControllers/genericButton";
import { PatientRoute } from "../PatientRoutes/PatientRoute";
import { usePatientRouteChanger } from "../PatientRoutes/routeChanger";
import { useTranslate } from "../hooks/useTranslate";
import { useNavigation } from "../state/navigationContext";
import { PatientColorMap } from "../layout/patientColorMap";
import {
  WaveArea,
  WaveAreaAlignment,
  WaveViewMainContent,
} from "../style/waveStyles";
import { PatientThemeImage } from "../themes/PatientThemeImage";

//region [[ Styles ]]

const DisclaimerContainerView = styled("div")(({ theme }) => ({
  display: "flex",
  flexFlow: "column",
  height: "100%",
  flexDirection: "column",
  "& .show-button": {
    width: "300px",
  },
}));

const DoctorImageContainer = styled("div")({
  marginBottom: "20px",
  "& img": {
    maxWidth: "300px",
  },
});

const BottomArea = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "100%",
}));

const DisclaimerTitle = styled("div")(({ theme }) => ({
  fontSize: "24px",
  marginBottom: "20px",
  fontWeight: "bold",
  color: PatientColorMap.HomepageTextColor,
}));

const DisclaimerText = styled("div")(({ theme }) => ({
  fontSize: "17px",
  fontWeight: 500,
  color: PatientColorMap.HomepageTextColor,
}));

//endregion [[ Styles ]]

//region [[ Props ]]

export interface DisclaimerContainerProps {}

//endregion [[ Props ]]

//region [[ Texts ]]
const DISCLAIMER_TITLE = "DISCALIMER_TITLE";
const DISCLAIMER_TEXT = "DISCLAIMER_TEXT";
const DISCLAIMER_BUTTON = "DISCLAIMER_BUTTON";
//endregion [[ Texts ]]

export const DisclaimerContainer = ({ ...props }: DisclaimerContainerProps) => {
  const routeChanger = usePatientRouteChanger();

  const onContinue = () => {
    routeChanger(PatientRoute.Result);
  };

  const { translate } = useTranslate();

  const { themeSettings } = useNavigation();
  const useGradient = themeSettings?.gradient ? "true" : "false";

  return (
    <DisclaimerContainerView>
      <WaveViewMainContent
        color={PatientColorMap.GradLight}
        gradient={useGradient}
        bottom_wave={"true"}
      >
        <DoctorImageContainer>
          {themeSettings && (
            <PatientThemeImage source={themeSettings.mainLogo} />
          )}
        </DoctorImageContainer>
        <DisclaimerTitle>{translate(DISCLAIMER_TITLE)}</DisclaimerTitle>
        <DisclaimerText>{translate(DISCLAIMER_TEXT)}</DisclaimerText>
      </WaveViewMainContent>
      <WaveArea alignment={WaveAreaAlignment.Bottom}>
        <BottomArea>
          <GenericButton
            onClick={onContinue}
            label={translate(DISCLAIMER_BUTTON)}
            className={"show-button"}
          />
        </BottomArea>
      </WaveArea>
    </DisclaimerContainerView>
  );
};
